import styled from '@emotion/styled'
import { Box } from '@mui/system'

import { colors } from 'config/theme'

export const TabsContainer = styled(Box)`
  border-color: ${colors.orange};
`
